export default "__VITE_ASSET__Cq0zp3gM__"